<template>
  <v-card class="chat-channels">
    <v-card-title class="pb-4">
      Kanały
      <div class="chat-channels__details">
        {{ getChannelsCount }}
      </div>
    </v-card-title>

    <v-card-text
      ref="chatChannels"
      class="chat-channels__list"
    >
      <ChatChannelsListElement
        v-for="channel in channels"
        :id="`channel-${channel.id}`"
        :key="channel.id"
        :channel="channel"
        :active="channel.id == currentChannelId"
        @change="changeChannel"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import utils from '@/helpers/utils';
import ChatChannelsListElement from '@/components/Chat/ChatChannelsListElement.vue';

export default {
  components: {
    ChatChannelsListElement,
  },

  props: {
    channels: {
      type: Array,
      required: true,
    },
    projectChannels: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currentChannelId() {
      return this.$route.params.channelId;
    },

    getChannelsCount() {
      return utils.getCounterWithSuffix(this.channels.length,
        'kanał', 'kanały', 'kanałów');
    },
  },

  watch: {
    channels() {
      if (this.channels[0].id === parseInt(this.currentChannelId, 10)) {
        this.$vuetify.goTo(0, { container: this.$refs.chatChannels });
      }
    },
  },

  methods: {
    changeChannel(channelId) {
      if (channelId !== parseInt(this.currentChannelId, 10)) {
        this.scrollToChannel(channelId);

        this.$router.push({
          name: this.projectChannels
          ? 'project-chat-channel' : 'chat-channel',
          params: { channelId },
        });
      }
    },

    scrollToChannel(channelId) {
      this.$vuetify.goTo(`#channel-${channelId}`, { container: this.$refs.chatChannels });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-channels {
  &__details {
    letter-spacing: 0.5px;
    font-size: 10px;
    font-weight: 400;
  }
  &__list {
    height: calc(100vh - 274px);
    min-height: 280px;
    overflow-y: scroll;
    padding-left: 16px;
    padding-right: 16px;

    &:after {
      content: "";
      position: absolute;
      z-index: 1;
      bottom: 0;
      height: 100%;
      left: 0;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255, 0), rgba(255,255,255, 1) 90%);
      width: 100%;
      height: 3em;
    }
  }
}
</style>
